import LegalPageLayout from "./LegalPageLayout";

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout title="Privacy Policy" lastUpdated="2026-04-21">
      <p>
        This page explains what data howisthe.surf collects, why, and what you can do
        about it. Plain English. No tricks.
      </p>

      <h2>Who we are</h2>
      <p>
        howisthe.surf is a surf-conditions web app. "We", "us", and "our" refer to the
        operators of howisthe.surf. You can reach us at{" "}
        <a href="mailto:hello@howisthe.surf">hello@howisthe.surf</a>.
      </p>

      <h2>What we collect</h2>
      <h3>If you create an account</h3>
      <p>
        We use Firebase Authentication. When you sign in with Google, Firebase receives
        your name, email, profile photo, and a Google-issued user ID. When you sign up
        with email and password, Firebase stores your email and a salted hash of your
        password — we never see or store the plaintext password.
      </p>

      <h3>If you post a report, vote, or like</h3>
      <p>
        We store the content you submit: wave size estimate, conditions, crowd level,
        comment, any media you upload, and the timestamp. Your display name and profile
        photo (from your sign-in provider) are attached so other users can see who posted.
      </p>

      <h3>Automatically collected</h3>
      <ul>
        <li>
          <strong>Analytics.</strong> We use Google Analytics 4 to understand how the app
          is used — which pages are viewed, which buttons are clicked, approximate
          location, and device/browser type. GA4 sets cookies for this.
        </li>
        <li>
          <strong>Error reporting.</strong> If the app crashes, we collect a stack trace
          and browser details via Sentry to debug it.
        </li>
        <li>
          <strong>Server logs.</strong> Our hosting provider (Vercel) logs request
          metadata — IP, user agent, URL — for operational purposes and keeps them for a
          short period.
        </li>
        <li>
          <strong>Local storage.</strong> Your unit preference (metric/imperial), home
          spot, multi-cam layout, and a flag that you've seen the welcome screen are
          stored in your browser. They never leave your device.
        </li>
      </ul>

      <h3>Email campaigns</h3>
      <p>
        If you've received an email from us, we log delivery and bounce events through
        Amazon SES so we know not to email addresses that fail permanently or flag us as
        spam. If you unsubscribe, we record that in a per-address suppression list and
        never email you again.
      </p>

      <h2>How we use it</h2>
      <ul>
        <li>
          To run the app — showing your home spot, your reports, your sign-in state.
        </li>
        <li>To moderate content when a report is flagged or spam-like.</li>
        <li>To understand what's working (analytics) and what's broken (errors).</li>
        <li>To send operational emails and, rarely, product updates.</li>
      </ul>
      <p>
        <strong>We don't sell your data.</strong> We don't share it with advertisers.
      </p>

      <h2>Sub-processors</h2>
      <p>Third parties we route data through to operate the app:</p>
      <ul>
        <li>
          <strong>Google Firebase</strong> — authentication and database (Firestore).
        </li>
        <li>
          <strong>Google Analytics 4</strong> — usage analytics.
        </li>
        <li>
          <strong>Sentry</strong> — error monitoring.
        </li>
        <li>
          <strong>Vercel</strong> — hosting.
        </li>
        <li>
          <strong>Amazon Web Services (SES)</strong> — transactional and campaign emails.
        </li>
        <li>
          <strong>Open-Meteo, NOAA NDBC, NWS</strong> — forecast and buoy data providers.
          We send them a lat/lon; they don't receive anything tied to your identity.
        </li>
      </ul>

      <h2>Your rights</h2>
      <p>
        If you're in the EU, UK, or California (or anywhere else with similar rules), you
        can ask us to:
      </p>
      <ul>
        <li>Send you a copy of the data we hold about you.</li>
        <li>Correct anything inaccurate.</li>
        <li>Delete your account and associated data.</li>
        <li>Stop processing your data for a specific purpose.</li>
      </ul>
      <p>
        Email <a href="mailto:hello@howisthe.surf">hello@howisthe.surf</a> and we'll take
        care of it within a reasonable time, usually under 30 days.
      </p>

      <h2>Retention</h2>
      <ul>
        <li>
          Surf reports auto-expire from the feed after a few hours; the underlying
          documents stay in Firestore until you delete them or we delete your account.
        </li>
        <li>
          Account data is kept as long as your account is active. Delete the account and
          we remove it.
        </li>
        <li>
          Unsubscribe entries are kept indefinitely — that's how we remember not to email
          you again.
        </li>
        <li>Analytics data is retained per GA4's default (14 months).</li>
      </ul>

      <h2>Cookies</h2>
      <p>
        We use a small number of first-party cookies for sign-in sessions and an analytics
        cookie from Google. We don't use tracking cookies for advertising.
      </p>

      <h2>International transfers</h2>
      <p>
        Our hosting and most sub-processors are based in the United States. If you use the
        app from outside the US, your data is transferred there. The sub-processors rely
        on standard contractual clauses or adequacy decisions for compliance.
      </p>

      <h2>Children</h2>
      <p>
        howisthe.surf is not directed at children under 13 (or 16 in the EU). If we learn
        we've accidentally collected data from a child, we'll delete it.
      </p>

      <h2>Changes</h2>
      <p>
        We'll update this page when things change. If the change is material, we'll note
        it at the top. The "Last updated" date at the top of this page tells you when this
        version took effect.
      </p>

      <h2>Contact</h2>
      <p>
        <a href="mailto:hello@howisthe.surf">hello@howisthe.surf</a>.
      </p>
    </LegalPageLayout>
  );
}
